import { render, staticRenderFns } from "./WaterLeakageCauseLocalizedPlumberIntervenedWithDocumentsQuestion.vue?vue&type=template&id=2ab59e0c"
import script from "./WaterLeakageCauseLocalizedPlumberIntervenedWithDocumentsQuestion.vue?vue&type=script&lang=ts"
export * from "./WaterLeakageCauseLocalizedPlumberIntervenedWithDocumentsQuestion.vue?vue&type=script&lang=ts"
import style0 from "./WaterLeakageCauseLocalizedPlumberIntervenedWithDocumentsQuestion.vue?vue&type=style&index=0&id=2ab59e0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports